/* @ngInject */
export function DownloadFileController($stateParams, DOCUMENT_TYPE, DocumentManager) {

    if ($stateParams['document'] != null) {
        DocumentManager.downloadFile("/" + $stateParams['document'], DOCUMENT_TYPE.ACCREDITATION_DOCUMENT);
    }
}
